<div class="actions-container"><button mat-raised-button class="new-button" (click)="addNewTask()">New Task</button>
</div>
